module.exports = __webpack_public_path__ + "img/s1-logo.60f7c037.png";